// extracted by mini-css-extract-plugin
module.exports = {"card":"cardLink_card__1kU4y","chevron":"cardLink_chevron__2LE0s","iconCol":"cardLink_iconCol__2tYqA"};